var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"d-flex align-items-center py-3 container position-relative w-100",class:{
    'justify-content-between': !_vm.orderElements
  },on:{"click":_vm.changeValueSelected}},[_c('h6',{staticClass:"text-left my-0",class:{
      'order-2': _vm.orderElements,
      'pl-3': !_vm.orderElements,
      'mr-2': _vm.orderElements
    }},[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('div',{staticClass:"mr-2 mb-1 d-flex align-items-center justify-content-center",class:{
      'border-img': !_vm.selected,
      'bg-active': _vm.selected,
      'order-1': _vm.orderElements
    }},[_c('i',{staticClass:"icon-size",class:{ 'icon-checkmark': _vm.selected }})])])}
var staticRenderFns = []

export { render, staticRenderFns }